// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"07fb545a","908":"13f3d7e3"}[chunkId] + ".chunk.css";
};